//IMPORTAÇÕES
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';

import { api_gateway } from '../../../conexoes/api';
import { revelarCancelarPedido } from "../../../redux/actions/index";
import { elipseVerde, fecharJanela, lixeiraVermelho } from '../../../utils/alternanciaIcones';
import { formatarMilhar } from '../../../utils/formatarMilhar';
import ColetaClickstream from '../../clickstreamAnalise/clickstreamColeta.js';
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao';
import MensagemAtencaoSelectSms from '../../componentesModais/mensagens/mensagemAtencaoSelectSms';
import MensagemErro from '../../componentesModais/mensagens/mensagemErro';
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';

import { validacaoAcaoPedidoSms } from './validarPedidoSms';

export default function CancelarPedido(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const { handleSubmit } = useForm();
    const [renderizar] = useState(false);
    const [quantidadeLinhasSelecionados, setQuantidadeLinhasSelecionados] = useState(-1);
    const [linhaRemover, setLinhaRemover] = useState('');
    const [mensagemErro, setMensagemErro] = useState("Ocorreu um erro ao executar esta ação");
    const [pedidos, setPedidos] = useState([]);
    const [itens, setItens] = useState([])
    const [itensInvalidos, setItensInvalidos] = useState([])
    const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
    const [revelarMensagemAtencaoConclusao, setRevelarMensagemAtencaoConclusao] = useState(false)
    const [revelarMensagemAtencaoInvalido, setRevelarMensagemAtencaoInvalido] = useState(false)
    const [revelarMensagemAtencaoContemItemInvalido, setRevelarMensagemAtencaoContemItemInvalido] = useState(false)
    const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
    const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
    const despacho = useDispatch();
    const modal = useRef();


    let itensTemp = []

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };


    const colunas = [{
        dataField: 'CODIGO_CLIENTE',
        text: 'Cliente',
        headerClasses: 'nao-selecionavel',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
    {
        dataField: 'NUMERO_PEDIDO',
        headerClasses: 'nao-selecionavel',
        text: 'ID do pedido',
        sort: true, 
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
    {
        dataField: 'PEDIDO_STATUS',
        headerClasses: 'nao-selecionavel',
        text: 'Status',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
    {
        dataField: 'QTD_SMS',
        headerClasses: 'nao-selecionavel',
        text: 'Quantidade  de SMS',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell ? cell.toFixed(2) : cell} MB</p>;
        }
    },
    {
        dataField: 'VALOR',
        headerClasses: 'nao-selecionavel',
        text: 'Valor',
        sort: true,
        formatter: (cell) => {
            const valor = parseFloat(cell);
            return <p className="fonte-cor-1 label-tabela-1 container-valor-pedido"> {(!valor || isNaN(valor)) ? <><p className="valor-rs-pedido">R$</p> <p className="fonte-cor-1 valor-pedido"> 0.00 </p></> : <><p className="valor-rs-pedido">R$</p> <p className="fonte-cor-1 valor-pedido"> {formatarMilhar(valor)}</p></>} </p>;
        }
    },
    {
        dataField: 'acoes',
        text: '',
        sort: false,
        headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
        formatter: () => {
            return (
                <Button variant="danger" className="botoes-tabela-acoes" size="sm" onClick={() => handleMensagemAtencao(false)}>
                    <img className="icone-botao-acao-tabela" src={lixeiraVermelho()} alt="remover-linha"/>
                </Button>
            )
        }
    }]


    const eventosLinhas = {
        onClick: (e, row) => {
            setLinhaRemover(row.NUMERO_PEDIDO);
        }
    }
    
    function handleLinhasSelecionadas(){
        setQuantidadeLinhasSelecionados(itensTemp.length)
        // if(itensTemp.length === 0){
        //     handleCancelar()
        // }
    }

    //verifica se o usuario selecionou linhas extras que nao sao permitidas na acao e aciona um alerta
    function handleLinhasSelecionadasIncapacitadas(){
        setQuantidadeLinhasSelecionados(itensTemp.length)
        if(itensTemp.length === 0){
            setRevelarMensagemAtencaoInvalido(true)
        }
        else if(itensTemp.length < props.itensSelecionados.length){
            setRevelarMensagemAtencaoContemItemInvalido(true)
        }
    }

    function handleRemoverLinha(IDPEDIDO){
        setRevelarMensagemAtencao(false)
        itensTemp = itens
        itens.forEach(function(e, index){
            if(IDPEDIDO == e.NUMERO_PEDIDO){
                itens.splice(index, 1);
            }
        })
        setItens(itensTemp)
        handleIdPedidos()
        handleLinhasSelecionadas()
    }

    async function handleSalvar(){
        handleMensagemSucesso(false)
    }

    async function handleCancelar() {
        itensTemp = []
        setSpinAtivo(false)
        despacho(revelarCancelarPedido(false))
        props.setRenderizar(!props.renderizar)
    }

    function handleIdPedidos(){
        let tempPedidos = []
        for (let i = 0; i < itensTemp.length; i++) {
            tempPedidos.push(itensTemp[i].NUMERO_PEDIDO)
        }
        setPedidos(tempPedidos)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function preencherTabela (){
            const validacao = await validacaoAcaoPedidoSms(props.itensSelecionados, 3)
            setItens(validacao.itensValidos)
            setItensInvalidos(validacao.itensInvalidos)
            itensTemp = validacao.itensValidos

            handleLinhasSelecionadas();
            handleLinhasSelecionadasIncapacitadas();
            handleIdPedidos();
            setSpinAtivo(false)
        }
        preencherTabela()
        
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [renderizar]);

    async function enviarCancelarPedido(){
        ColetaClickstream(1454) // VirtueyesPedidosSMSDropAcoesCancelar
        setSpinAtivo(true)
        await api_gateway.post('/m1/alterar/sms_pedido', {
            "dados":{
                'cd_sms_pedido_status': 3,
            },
            "condicao":{
                'cd_sms_pedido': pedidos,
            }
        })
        .then(function () {
            setSpinAtivo(false)
            handleMensagemSucesso(false)
        })
        .catch(function (error) {
            setSpinAtivo(false)
            setMensagemErro(error.response.data.info)
            handleMensagemErro(false)
        });
    }

    function handleMensagemAtencao(confirmacao){
        if(revelarMensagemAtencao === false){
            setRevelarMensagemAtencao(true)
        }else{
            setRevelarMensagemAtencao(false)
        }
        if(confirmacao ===true){
            handleRemoverLinha(linhaRemover)
        }
    }

    function handleMensagemAtencaoConclusao(confirmacao){
        if(revelarMensagemAtencaoConclusao === false){
            setRevelarMensagemAtencaoConclusao(true)
        }else{
            setRevelarMensagemAtencaoConclusao(false)
        }
        if(confirmacao ===true){
            handleSalvar()
        }
    }

    function handleMensagemSucesso(){
        if(revelarMensagemSucesso === false){
            setRevelarMensagemSucesso(true)
        }else{
            setRevelarMensagemSucesso(false)
            handleCancelar()
        }
    }

    function handleMensagemErro(confirmacao){
        if(revelarMensagemErro === false){
            setRevelarMensagemErro(true)
        }else{
            setRevelarMensagemErro(false)
        }
        if(confirmacao ===true){
            //ALGUMA FUNÇÃO
        }
    }
    
    return(
        <Form ref={modal} onSubmit={handleSubmit(() => enviarCancelarPedido())}>
            <div className="modal-acao-cancelar-pedido fundo-cor-6">
                { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
                <Form.Row>
                    <Col>
                        <img className="icone-label-janela nao-selecionavel" src={elipseVerde()} alt="elipse"/>
                        <Form.Label>
                            <div className="fonte-cor-1 label-janela">Cancelar pedido</div>
                        </Form.Label>
                        <Button className="botao-fechar-janela" variant="danger" onClick={() => handleCancelar()}>
                            <img className="botao-fechar-janela-icone" src={fecharJanela()} alt="fechar-janela"/>
                        </Button>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <div className="container-tabela-modal">
                            <BootstrapTable
                                classes="tabela-transparente-modais"
                                condensed
                                keyField='NUMERO_PEDIDO' 
                                data={itens} 
                                columns={colunas} 
                                rowEvents={eventosLinhas}
                                noDataIndication={!spinAtivo && "Nenhum item encontrado"}
                                bootstrap4
                            />
                        </div>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">{quantidadeLinhasSelecionados} linhas selecionadas</span>
                    </Col>
                </Form.Row>
                <Form.Row className="espaco-ativar-linha">
                    <Col>
                        <Button  type="submit" className="botao-confirmar" variant="success" size="sm">
                            <div className="fonte-cor-4">Confirmar</div>
                        </Button>
                        <Button className="botao-cancelar" variant="success" size="sm" onClick={() => handleCancelar()}>
                            <div className="fonte-cor-2">Cancelar</div>
                        </Button>
                    </Col>
                </Form.Row>
            </div>
            { revelarMensagemSucesso &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemSucesso
                            handleMensagemSucesso={handleMensagemSucesso}
                            mensagemTitulo="Sucesso"
                            mensagemParagrafo1="Seu(s) pedido(s) foram cancelados."
                            mensagemBotao="Ok"
                        />
                    </div>
                </div>
            }
            { revelarMensagemAtencaoConclusao &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemAtencao
                            handleMensagemAtencao={handleMensagemAtencaoConclusao}
                            mensagemTitulo="Atenção"
                            mensagemParagrafo1="Tem certeza que deseja cancelar este(s) pedido(s)?"
                            mensagemBotao="Confirmar"
                        />
                    </div>
                </div>
            }
            { revelarMensagemAtencao &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemAtencao
                            handleMensagemAtencao={handleMensagemAtencao}
                            mensagemTitulo="Remover pedido?"
                            mensagemBotao="Remover"
                        />
                    </div>
                </div>
            }
            { revelarMensagemErro &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemErro
                            handleMensagemErro={handleMensagemErro}
                            mensagemTitulo="Erro"
                            mensagemParagrafo1={mensagemErro}
                            mensagemBotao="Retornar"
                        />
                    </div>
                </div>
            }
            { revelarMensagemAtencaoInvalido &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemAtencaoSelectSms
                            handleMensagemAtencao={() =>  setRevelarMensagemAtencaoInvalido(!revelarMensagemAtencaoInvalido)}
                            mensagemTitulo="Não é possível solicitar o cancelamento."
                            mensagemParagrafo1="Os pedidos abaixo foram retirados pois já foram cancelados ou processados:"
                            mensagemItem="Código do pedido"
                            dados={itensInvalidos}
                            mensagemBotao="Voltar"
                        />
                    </div>
                </div>
            }
            { revelarMensagemAtencaoContemItemInvalido &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <MensagemAtencaoSelectSms
                            handleMensagemAtencao={() =>  setRevelarMensagemAtencaoContemItemInvalido(!revelarMensagemAtencaoContemItemInvalido)}
                            mensagemTitulo="Não é possível solicitar o cancelamento."
                            mensagemParagrafo1="Os pedidos abaixo foram retirados pois já foram cancelados ou processados:"
                            mensagemItem="Código do pedido"
                            dados={itensInvalidos}
                            mensagemBotao="Continuar"
                        />
                    </div>
                </div>
            }
        </Form>
    )
}
